import { Illus, LinkAnchor } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { toDateTime } from '../../../../util/date'
import { AppPath } from '../../../AppPath'
import { usePrincipal } from '../../../authentication'
import { Feedback } from '../../../organisms/feedback/Feedback'
import { WriskTrans } from '../../../organisms/trans'
import { FullPage } from '../../../templates'
import { usePolicy } from '../PolicyProvider'

const tKey = TKey('pages.cancel-confirmation')

export const CancellationConfirmationPage: FunctionComponent = () => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const { policy } = usePolicy()
  const { isAdmin } = usePrincipal()

  const onContinue = useCallback(() => navigate(AppPath.HOME), [navigate])

  const subheader = (
    <WriskTrans
      t={t}
      i18nKey={tKey('subheader')}
      values={{
        terminatedAt: t(tFormats('datetime.medium'), {
          value: toDateTime(policy.policyDetail.terminatedAt),
        }),
      }}
    />
  )

  return (
    <FullPage
      pageId='cancel-confirmation'
      header={t(tKey('header'))}
      subheader={subheader}
      upperHeader={
        <Illus alt='CancelSuccess' data-testid='cancel-success' illus='cancelSuccess' />
      }
    >
      <LinkAnchor onClick={onContinue} variant='standalone'>
        {t(tKey('actions.view-dashboard'))}
      </LinkAnchor>
      {!isAdmin && <Feedback type='cancellation' tags={{ policyId: policy.policyId }} />}
    </FullPage>
  )
}
